import { useState, useEffect } from 'react';

// mui
import {
    Typography
} from '@mui/material';

// third-party
import { intervalToDuration } from 'date-fns';
import { useSelector } from 'react-redux';

const TimerComponent = ({ paddingTopValue = 0, paddingRightValue = 0 }) => {

    const [timer, setTimer] = useState('00:00:00');
    const currentTask = useSelector((state) => state.timesheet.currentTask);

    function formatDurationAsTime(duration) {
        const hours = String(duration.hours).padStart(2, '0');
        const minutes = String(duration.minutes).padStart(2, '0');
        const seconds = String(duration.seconds).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        let startTime = new Date();
        let durationInSeconds = currentTask.durationInSeconds ? currentTask.durationInSeconds : 0;
        if (currentTask.punchStatus === 'start' && currentTask.durationInSeconds === null && currentTask.lastPauseTime === null) {
            startTime = new Date(currentTask.startTime);
        } if (currentTask.punchStatus === 'start' && currentTask.durationInSeconds !== null && currentTask.lastPauseTime !== null) {
            startTime = new Date(currentTask.lastRestartTime);
        } else if (currentTask.punchStatus === 'pause') {
            const duration = intervalToDuration({ start: 0, end: currentTask.durationInSeconds * 1000 });
            const formattedDuration = formatDurationAsTime(duration);
            setTimer(formattedDuration);
            return;
        } else if (currentTask.punchStatus === 'stop') {
            return;
        }

        const intervalId = setInterval(() => {
            const now = new Date();
            // * Calculate the elapsed time since the task was started
            const duration = intervalToDuration({ start: startTime, end: now });
            const elapsedSeconds = duration.hours * 3600 + duration.minutes * 60 + duration.seconds;
            const totalDurationInSeconds = durationInSeconds + elapsedSeconds;
            const totalDuration = intervalToDuration({ start: 0, end: totalDurationInSeconds * 1000 });
            const formattedDuration = formatDurationAsTime(totalDuration);
            setTimer(formattedDuration);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [currentTask]);

    return <Typography sx={{ paddingTop: paddingTopValue, paddingRight: paddingRightValue }} variant="subtitle1">
        {timer}
    </Typography>;
};

export default TimerComponent;
